/*jslint node: true, browser: true, nomen: true */

"use strict";

var ko = require("pli/knockout");

//-------------------------------------------
function UploadViewModelExtras(factories) {
    this.file = factories.createFileViewModel();
    this.iconClass = ko.computed(this._getIconClass, this);
    this.message = ko.computed(this._getMessage, this);
    this.fileDragDropSupported = !!window.FileReader;
}

//-------------------------------------------
UploadViewModelExtras.prototype._getIconClass = function getIconClass() {
    switch (this.file.extras.uploadState()) {
    case "done":
        return "sprite-checked-16";
    case "fail":
        return "sprite-warning-16";
    default:
        return "sprite-progress-15 sprite-spin";
    }
};

//-------------------------------------------
UploadViewModelExtras.prototype._getMessage = function getMessage() {
    switch (this.file.extras.uploadState()) {
    case "done":
        if (typeof this.getUploadCompleteMessage === "function") {
            return this.getUploadCompleteMessage(this.file.fileName());
        }

        return "File " + this.file.fileName() + " has been uploaded.";
    case "fail":
        return this.file.extras.uploadMessage();
    default:
        return "Uploading file " + this.file.fileName() + ". Completed: " + this.file.extras.uploadProgress();
    }
};

module.exports = function createUploadViewModelExtras(factories) {
    return new UploadViewModelExtras(factories);
};



//////////////////
// WEBPACK FOOTER
// ./app/filestore/uploadViewModelExtras.js
// module id = 508
// module chunks = 49